import classNames from 'classnames'
import * as React from 'react'
import { Dot, DotProps } from 'recharts'

import { ChartWrapperContext } from './ChartWrapper'
import { CHART_ITEM_COLORS, ChartItemColorType } from './constants'

interface LineDotProps extends DotProps {
  dataKey?: string
  value?: unknown
  color?: ChartItemColorType
  isActive?: boolean
}

export function LineDot({ cx, cy, r = 4, dataKey, color, className, isActive, value }: LineDotProps) {
  const { setActiveKey } = React.useContext(ChartWrapperContext)
  const lineColor = color ? CHART_ITEM_COLORS[color] : undefined

  if (value === null) return null

  return (
    <Dot
      cx={cx}
      cy={cy}
      r={isActive ? r + 1 : r}
      className={classNames(className, 'fill-current', lineColor)}
      onMouseEnter={() => setActiveKey(dataKey ?? null)}
      onMouseLeave={() => setActiveKey(null)}
    />
  )
}

export function RedGreenDot({ cx, cy, value, isActive }: LineDotProps) {
  if (typeof value !== 'number') return null

  return (
    <LineDot
      cx={cx}
      cy={cy}
      r={5}
      value={value}
      isActive={isActive}
      color={value > 0 ? 'green' : 'red'}
      className="stroke-bg-primary stroke-1"
    />
  )
}
